import { render } from "./ServicesComponent.vue?vue&type=template&id=199d0733&scoped=true"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=199d0733&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199d0733"]])

export default __exports__